module.exports = __webpack_public_path__ + "media/images/emblems/Surses_(Kreis)_wappen-1095220c94f3d04d5c7d6c8e41ba31d7.svg";